import { DomManagement } from './domManagement';
/**
 * Class used to provide helper for timing
 */
var TimingTools = /** @class */ (function () {
    function TimingTools() {
    }
    /**
     * Polyfill for setImmediate
     * @param action defines the action to execute after the current execution block
     */
    TimingTools.SetImmediate = function (action) {
        if (DomManagement.IsWindowObjectExist() && window.setImmediate) {
            window.setImmediate(action);
        }
        else {
            setTimeout(action, 1);
        }
    };
    return TimingTools;
}());
export { TimingTools };
//# sourceMappingURL=timingTools.js.map